import type { SVGProps } from "react";
import * as React from "react";
const SvgSparkles = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14 5c0-.31.255-.556.558-.627a2.441 2.441 0 0 0 1.815-1.815C16.444 2.255 16.69 2 17 2c.31 0 .556.255.627.558.21.898.917 1.605 1.815 1.815.303.071.558.316.558.627 0 .31-.255.556-.558.627a2.441 2.441 0 0 0-1.815 1.815C17.556 7.745 17.31 8 17 8c-.31 0-.556-.255-.627-.558a2.441 2.441 0 0 0-1.815-1.815C14.255 5.556 14 5.31 14 5ZM1 12c0-.552.451-.991.996-1.082a6.005 6.005 0 0 0 4.922-4.922C7.008 5.45 7.448 5 8 5s.991.451 1.082.996a6.005 6.005 0 0 0 4.922 4.922c.545.09.996.53.996 1.082s-.451.991-.996 1.082a6.005 6.005 0 0 0-4.922 4.922C8.992 18.55 8.552 19 8 19s-.991-.451-1.082-.996a6.005 6.005 0 0 0-4.922-4.922C1.45 12.992 1 12.552 1 12Zm17 2c-.414 0-.741.34-.835.744a3.255 3.255 0 0 1-2.421 2.42c-.404.095-.744.422-.744.836s.34.741.744.835a3.255 3.255 0 0 1 2.42 2.421c.095.404.422.744.836.744s.741-.34.835-.744a3.255 3.255 0 0 1 2.421-2.42c.404-.095.744-.422.744-.836s-.34-.741-.744-.835a3.255 3.255 0 0 1-2.42-2.421C18.74 14.34 18.413 14 18 14Z"
    />
  </svg>
);
export default SvgSparkles;
